// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-PrimaryButton-module--cls1--MvH3v","cls2":"styles-PrimaryButton-module--cls2--_6Zez styles-PrimaryButton-module--cls1--MvH3v"};